import { IResourceComponentsProps } from "@refinedev/core";
import { AntdInferencer } from "@refinedev/inferencer/antd";
import Cw8Create from "components/cw8/Cw8Create";

export const FragmentPubsCreate: React.FC<IResourceComponentsProps> = () => {
    // return <AntdInferencer />;

    const resourceName :string = 'fragmentPub';
    return (
        <Cw8Create
            resourceName = {resourceName}
        ></Cw8Create>
    );   
};
